import { useQuery } from '@tanstack/react-query';
import {
  DashboardMetrics,
  MetricPeriod,
  metricsApi,
} from '@/api/metricService';
import { useAuth } from '@/providers/AuthProvider';
import { metricKeys } from './keys/metric.keys';
// import type { DashboardMetrics, MetricPeriod } from '@packages/database/types';

export const useMetrics = (period: MetricPeriod = '7d', projectId?: string) => {
  const { organization } = useAuth();
  const orgId = organization?.id ?? '';

  return useQuery<DashboardMetrics>({
    queryKey: metricKeys.dashboard(orgId, period, projectId),
    queryFn: () => metricsApi.dashboard(period, projectId),
    enabled: !!orgId,
    staleTime: 60 * 1000,
  });
};
